export const productAPIPath = {
  11: 'car',
  12: 'housemaid',
  13: 'holiday',
  14: 'travel',
  15: 'interior',
  16: 'student',
  17: 'home_fire',
  18: 'accident',
  20: 'home_fire',
  22: 'pet',
}
export const onlyPersonalProductId = [12, 13, 14, 16, 18, 22]

export const onlyCompanyProductId = [15]
